/**
 * Portal Appearance popover: stable focus target for Radix `onOpenAutoFocus` (query within Content ref).
 */
export const APPEARANCE_PANEL_INITIAL_FOCUS_ATTR = 'data-appearance-panel-initial-focus' as const;

export const appearancePanelInitialFocusSelector = `[${APPEARANCE_PANEL_INITIAL_FOCUS_ATTR}]`;
